import { postMethod } from "./Network";
import { Api } from "../Config/Config";
export const LoadMerchantInfo = (GUID, CSP) => {
  var url = `${Api}/COMService`; //POSSaveOrder TMPPOSSO
  return postMethod(
    url,
    "{'SERVICENAME':'CallApi','JSONSTRING':" +
      JSON.stringify("{'SERVICENAME':'LMI','MasterID':" + GUID + "}") +
      ",'CSP':'" +
      CSP +
      "'}"
  ); //  return postMethod(url, "{'SERVICENAME':'LPI','MasterID':" + GUID + "}");
};

export const LoadProductIndo = (GUID, CSP) => {
  var url = `${Api}/COMService`; //POSSaveOrder TMPPOSSO
  return postMethod(
    url,
    "{'SERVICENAME':'CallApi','JSONSTRING':" +
      JSON.stringify("{'SERVICENAME':'LPI','MasterID':" + GUID + "}") +
      ",'CSP':'" +
      CSP +
      "'}"
  );
};
